import SettingsUsers from 'components/Settings/Users/Users'

const View = () => <SettingsUsers />

export default View
